import { IVirtualFenceCircle } from 'app/shared/model/virtual-fence-circle.model';
import { IVirtualFencePolygon } from 'app/shared/model/virtual-fence-polygon.model';
import { IVehiclePosition } from 'app/shared/model/vehicle-position.model';

export interface IVirtualFenceCircleAlert {
  id?: number | string;
  type?: string | null;
  fenceType?: string | null;
  virtualFenceCircle?: IVirtualFenceCircle | null;
  virtualFencePolygon?: IVirtualFencePolygon | null;
  vehiclePosition?: IVehiclePosition | null;
}

export const defaultValue: Readonly<IVirtualFenceCircleAlert> = {};
